




import {Component, Ref, Vue} from 'vue-property-decorator'
import Tariff from '../Tarification/Tariff.vue';
import {TarificationTypes, TarificationTransports} from "@/store/tarification/types";

Component.registerHooks([
  'beforeRouteLeave',
])
@Component({components: {Tariff}})
export default class CustomProviderTariff extends Vue{
  @Ref('tariffCustom') tariff: any;
  private partnerType: TarificationTypes = TarificationTypes.OPERATOR
  private tarificationTransport: TarificationTransports = TarificationTransports.CUSTOM

  beforeRouteLeave(to:any, from:any, next:any) {
    this.tariff.beforeLeave(to,from,next)
  }
}
